"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SBFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_200)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_200`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.91992 0H34.0801V24.0003H-1.91992V0Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.91992 23.9998V-0.000244141H34.0801",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.91992 21.8786V23.9998H1.26207L34.0801 2.12109V-0.000244141H30.8981L-1.91992 21.8786Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10502 1.64917L4.46502 2.75701H5.62982L4.68742 3.44165L5.04742 4.54956L4.10502 3.86486L3.16248 4.54956L3.52248 3.44165L2.58008 2.75701H3.74495L4.10502 1.64917ZM10.0551 1.64917L10.4152 2.75701H11.5801L10.6377 3.44165L10.9977 4.54956L10.0551 3.86486L9.11275 4.54956L9.47275 3.44165L8.53035 2.75701H9.69515L10.0551 1.64917ZM4.10502 7.4501L4.46502 8.55794H5.62982L4.68742 9.24265L5.04742 10.3506L4.10502 9.66579L3.16248 10.3506L3.52248 9.24265L2.58008 8.55794H3.74495L4.10502 7.4501ZM10.0551 7.4501L10.4152 8.55794H11.5801L10.6377 9.24265L10.9977 10.3506L10.0551 9.66579L9.11275 10.3506L9.47275 9.24265L8.53035 8.55794H9.69515L10.0551 7.4501ZM7.08008 4.54956L7.44008 5.65741H8.60502L7.66248 6.34211L8.02248 7.4501L7.08008 6.76532L6.13768 7.4501L6.49768 6.34211L5.55514 5.65741H6.72008L7.08008 4.54956Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_200`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SBFlag };
